import { Component, ViewChild } from '@angular/core';
import {
  Platform,
  App,
  MenuController,
  Nav,
  IonicApp,
  Events,
  ModalController
} from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ProfileServiceProvider } from '../providers/profile-service/profile-service';
import { FacebookServiceProvider } from '../providers/facebook-service/facebook-service';
import { ShareServiceProvider } from '../providers/share-service/share-service';
import { RequestServiceProvider } from '../providers/request-service/request-service';
import { ToastServiceProvider } from '../providers/toast-service/toast-service';
import { FirebaseServiceProvider } from '../providers/firebase-service/firebase-service';
import { LoaderServiceProvider } from '../providers/loader-service/loader-service';
import { AppSettings } from './app.settings';
import { SocialSharing } from '@ionic-native/social-sharing';
import { MessageFactory } from './factories/message.factory';
import { FtueServiceProvider } from '../providers/ftue-service/ftue-service';
import { FlurryProvider } from '../providers/flurry/flurry';
import { UtilsServiceProvider } from '../providers/utils-service/utils-service';
import { Device } from '@ionic-native/device';

const win: any = window;

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = this.profileService.getUser() ? 'TabsPage' : 'WelcomePage';
  user: any = {};
  model;
  deferredPrompt;
  private win: any = window;
  private showTutorial = true;

  constructor(
    private platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    private device: Device,
    private app: App,
    private menuCtrl: MenuController,
    private facebookService: FacebookServiceProvider,
    private events: Events,
    private profileService: ProfileServiceProvider,
    public shareService: ShareServiceProvider,
    public requestService: RequestServiceProvider,
    public toastService: ToastServiceProvider,
    public loaderService: LoaderServiceProvider,
    public modalCtrl: ModalController,
    public socialSharing: SocialSharing,
    public ftueService: FtueServiceProvider,
    public messageFactory: MessageFactory,
    private analytics: FlurryProvider,
    private firebase: FirebaseServiceProvider,
    public utilsService: UtilsServiceProvider
  ) {
    this.reloadUser();
    this.events.subscribe('login', () => {
      this.reloadUser();
      this.verifyTutorial();
    });

    this.events.subscribe('user:instagramLogIn', token => {
      this.nav.setRoot('HomePage', { token: token });
    });

    this.events.subscribe('logout', () => {
      this.utilsService.removeClass(
        document.getElementsByClassName('app-root')[0],
        'loggedIn'
      );
      this.showTutorial = true;
      this.nav.setRoot('WelcomePage');
    });

    platform.resume.subscribe(() => {
      this.utilsService.handleBranch();
      this.utilsService.handleBranchWeb();
    });

    platform.ready().then(() => {
      window.addEventListener('beforeinstallprompt', e => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        this.deferredPrompt = e;
        this.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.deferredPrompt.userChoice.then(choiceResult => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          this.deferredPrompt = null;
        });
      });
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      splashScreen.hide();
      this.checkIPhoneVersion();
      this.notificationSetup();
      statusBar.overlaysWebView(true);
      statusBar.backgroundColorByHexString('#ffffff');
      this.utilsService.handleBranch();
      this.utilsService.handleBranchWeb();
      // this.logout();
      if (AppSettings.isApp) {
        this.setupOpenWith();
      }

      app.viewWillEnter.subscribe(() => {
        menuCtrl.close();
      });

      this.facebookService.init();
      this.analytics.flurryAnalyticsInit();
    });
  }

  /**
   * Add class is iPhone x
   *
   * @memberof MyApp
   */
  checkIPhoneVersion() {
    this.model = this.device.model;
    if (this.model) {
      const iPhoneX =
        this.model.includes('iPhone10') || this.model.includes('iPhone11');
      this.utilsService.setDevice(iPhoneX);

      if (iPhoneX) {
        this.utilsService.addClass(
          document.getElementsByClassName('app-root')[0],
          'iPhoneX'
        );
      }
    }
  }

  verifyTutorial() {
    this.ftueService.getTutorial(this.user.id).subscribe(
      (data: any) => {
        if (data.tutorial !== true && this.showTutorial) {
          this.showTutorial = false;
          this.ftueService.setTutorial(this.user.id).subscribe(
            () => {
              this.nav.setRoot('OnboardingPage');
            },
            error => {
              if (error.status === 403) {
                this.profileService.logout();
              } else {
                this.toastService.show(
                  this.messageFactory.getMessage('BACKEND_ERROR')
                );
              }
            }
          );
        } else {
          this.nav.setRoot('TabsPage');
        }
      },
      () => {
        this.toastService.show(this.messageFactory.getMessage('BACKEND_ERROR'));
      }
    );
  }

  reloadUser() {
    this.user = this.profileService.getUser();
  }

  home() {
    this.app.getRootNav().setRoot('TabsPage');
  }

  // masterFolio() {
  //   this.app
  //     .getRootNav()
  //     .setRoot('TabsPage')
  //     .then(() => {
  //       this.events.publish('tabs-master-folio');
  //     });
  // }

  search() {
    this.app
      .getRootNav()
      .setRoot('TabsPage')
      .then(() => {
        this.events.publish('tabs-search');
      });
  }

  checkOut() {
    this.nav.push('AvailableCreditsPage');
  }

  logout() {
    this.showTutorial = true;
    this.profileService.logout();
    this.nav.setRoot('WelcomePage');
  }

  inviteFriends() {
    if (AppSettings.isApp) {
      this.socialSharing.share(`https://ask.lubbu.com`, 'Lubbu');
    } else {
      this.shareService.presentShare();
    }
  }

  settings() {
    this.nav.push('SettingsPage');
  }

  newLubbu() {
    // this.nav.push('NewLubbuPage');

    this.app
      .getRootNav()
      .setRoot('TabsPage')
      .then(() => {
        this.events.publish('tabs-new-lubbu');
      });
  }

  setupOpenWith() {
    if (this.platform.is('md')) {
      this.win.plugins.intentShim.onIntent(intent => {
        console.log('Received Intent: ' + intent.extras);
        this.loaderService.showLoader();
        let url =
          intent.extras.url || intent.extras['android.intent.extra.TEXT'];
        this.requestService.generateAskFromLink(url).subscribe(
          data => {
            this.loaderService.dismissLoader();
            let modal = this.modalCtrl.create('JustAskModalPage', {
              ask: data
            });
            modal.present();
          },
          err => {
            this.loaderService.dismissLoader();
            if (err && err.status === 403) {
              this.toastService.show('You must login before continuing');
            } else {
              this.toastService.show('Error getting product details');
              this.nav.push('GiftCardsPage');
            }
          }
        );
      });
    }

    // // Increase verbosity if you need more logs
    // this.win.cordova.openwith.setVerbosity(this.win.cordova.openwith.DEBUG);
    //
    // let initSuccess = () => {
    //   console.log('init success!');
    // };
    //
    // let initError = (err) => {
    //   console.log('init failed: ' + err);
    // };
    //
    // // Initialize the plugin
    // this.win.cordova.openwith.init(initSuccess, initError);
    // let self = this;
    // let myHandler = function (intent) {
    //   console.log('intent received', intent, arguments);
    //
    //   console.log('  action: ' + intent.action); // type of action requested by the user
    //   console.log('  exit: ' + intent.exit); // if true, you should exit the app after processing
    //
    //   if (intent.items.length > 0) {
    //     for (var i = 0; i < intent.items.length; ++i) {
    //       var item = intent.items[i];
    //       console.log(item);
    //       if (item) {
    //         console.log('  type: ', item.type);   // mime type
    //         console.log('  uri:  ', item.uri);     // uri to the file, probably NOT a web uri
    //
    //         // some optional additional info
    //         console.log('  text: ', item.text);   // text to share alongside the item, iOS only
    //         console.log('  name: ', item.name);   // suggested name of the image, iOS 11+ only
    //         console.log('  utis: ', item.utis);
    //         console.log('  path: ', item.path);   // path on the device, generally undefined
    //       }
    //     }
    //   }
    //   else {
    //     if (intent.exit) {
    //       self.win.cordova.openwith.exit();
    //     }
    //   }
    // };
    // self.win.cordova.openwith.addHandler(myHandler);
  }

  /**
   * Notifications firebase on the fly
   *
   * @private
   * @memberof MyApp
   */
  private async notificationSetup() {
    if (this.model) {
      await this.firebase.getToken();
      this.firebase.onNotifications().subscribe(msg => {
        console.log(JSON.stringify(msg));
        this.toastService.show(msg.body);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts